// 分享注册，领管店VIP
const Share = () => import('../../pages/share/share.vue')
const router = [
  {
    path: '/share/share/:token/:sisscloudtokenid?/:otherData?',
    component: Share,
    name: 'Share',
    meta: {
      title: '分享好友，领管店VIP'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  }
]
export default router
